import Cookies from 'cookies-js'
import Storage from './storage'                                                                                                                        



function setCookies(key, value) {
  // Cookies.set(key, value, options)  //正式服
  Cookies.set(key, value)           //测试服 && 本地
}

function getCookies(key) {
  return Cookies.get(key)
}

function delCookies(key) {
  Cookies.expire(key, options)
}

export function setName (name) {
  if (!name) {
    delCookies('name')
  } else {
    setCookies('name', name)
  }
}

export function getName () {
  return getCookies('name')
}

export function setToken(token) {
  if (token) {
    Storage.set('sftv_token',token)
  } else {
    Storage.remove('sftv_token')
  }
}

export function getToken () {
  let uToken = Storage.get('sftv_token')

  if (!uToken) {
    uToken = false
  }

  return uToken
}

export function setUserInfo (userInfo) {
  if (!userInfo || JSON.stringify(userInfo) === '{}') {
    Storage.remove('userInfo')
    Storage.remove('avatar')
  } else {
    Storage.set('userInfo', userInfo)
    Storage.set('avatar', userInfo.avatar.o)
  }
}

export function setSearchHistory(historyList) {
  Storage.set('searchHistory', historyList)
}

export function removeSearchHistory() {
  Storage.remove('searchHistory')
}

export function getSearchHistory() {
  return Storage.get('searchHistory');
}

export function getUserInfo () {
  let uInfo = Storage.get('userInfo')
  if (!uInfo) {
    uInfo = false
  }
  
  return uInfo
}

export function setLocalPublicKey(keyInfo) {
  Storage.set('localPublicKey',keyInfo)
}

export function getLocalPublicKey() {
  return Storage.get('localPublicKey') || null
}




// WEBPACK FOOTER //
// ./src/utils/auth.js